import React, { useState } from 'react';
import './Navbar.css';
import { useScrollPosition, useActiveSection } from '../hooks';

const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isScrolled } = useScrollPosition(50);
  const activeSection = useActiveSection({
    sectionIds: ['home', 'about', 'education', 'teachers', 'gallery', 'contact'],
    offset: 150,
  });

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = isScrolled ? 80 : 140;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - navbarHeight,
        behavior: 'smooth'
      });
    }
    closeMobileMenu();
  };

  const menuItems = [
    {
      id: 'home',
      label: 'Ana Sayfa',
      icon: 'https://cdn.lordicon.com/wmwqvixz.json'
    },
    {
      id: 'about',
      label: 'Hakkımızda',
      icon: 'https://cdn.lordicon.com/jnzhohhs.json'
    },
    {
      id: 'education',
      label: 'Eğitim',
      icon: 'https://cdn.lordicon.com/wxnxiano.json'
    },
    {
      id: 'teachers',
      label: 'Öğretmenler',
      icon: 'https://cdn.lordicon.com/dxjqoygy.json'
    },
    {
      id: 'gallery',
      label: 'Galeri',
      icon: 'https://cdn.lordicon.com/vixtkkbk.json'
    },
    {
      id: 'contact',
      label: 'İletişim',
      icon: 'https://cdn.lordicon.com/diihvcfp.json'
    },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      {/* Top Contact Bar */}
      <div className={`navbar-top ${isScrolled ? 'navbar-top-hidden' : ''}`}>
        <div className="navbar-top-content">
          <div className="navbar-top-left">
            <a href="tel:05389466443" className="navbar-top-item">
              <lord-icon
                src="https://cdn.lordicon.com/srsgifqc.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '22px', height: '22px' }}
              />
              <span>0538 946 64 43</span>
            </a>
            <span className="navbar-top-divider">|</span>
            <a href="mailto:info@cennetincocuklari.com" className="navbar-top-item">
              <lord-icon
                src="https://cdn.lordicon.com/diihvcfp.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '22px', height: '22px' }}
              />
              <span>info@cennetincocuklari.com</span>
            </a>
          </div>
          <div className="navbar-top-right">
            <span className="navbar-top-item">
              <lord-icon
                src="https://cdn.lordicon.com/surcxhka.json"
                trigger="hover"
                colors="primary:#ffffff,secondary:#ffffff"
                style={{ width: '22px', height: '22px' }}
              />
              <span>Mevlana Mah. Esenyurt, İstanbul</span>
            </span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div className="navbar-main">
        <div className="navbar-main-content">
          {/* Logo */}
          <a href="#home" onClick={(e) => scrollToSection(e, 'home')} className="navbar-logo">
            <img
              src="/images/logo-renkli.png"
              alt="Cennetin Çocukları"
              className="navbar-logo-img"
            />
          </a>

          {/* Menu */}
          <ul className={`navbar-menu ${mobileMenuOpen ? 'navbar-menu-open' : ''}`}>
            {menuItems.map((item) => (
              <li key={item.id} className="navbar-menu-item">
                <a
                  href={`#${item.id}`}
                  className={`navbar-menu-link ${activeSection === item.id ? 'active' : ''}`}
                  onClick={(e) => scrollToSection(e, item.id)}
                >
                  <lord-icon
                    src={item.icon}
                    trigger="hover"
                    colors={activeSection === item.id ? "primary:#EF7D3C" : "primary:#333333"}
                    style={{ width: '24px', height: '24px' }}
                  />
                  <span>{item.label}</span>
                </a>
              </li>
            ))}
          </ul>

          {/* CTA Button - Phone Call */}
          <a
            href="tel:05389466443"
            className="navbar-cta"
          >
            <lord-icon
              src="https://cdn.lordicon.com/srsgifqc.json"
              trigger="hover"
              colors="primary:#ffffff"
              style={{ width: '22px', height: '22px' }}
            />
            <span>Randevu Al</span>
          </a>

          {/* Mobile Toggle */}
          <button className="navbar-toggle" onClick={toggleMobileMenu}>
            <i className={mobileMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
